export default "__VITE_ASSET__0inpoNSY__"